<template>
  <div class="wrapper-editor">
    <Header :quiz="quiz" :mode="quiz.mode" />
    <div class="question" v-for="(question,index) in quiz.questions" v-bind:key="index">
      <EditorQuestion :question="question" :quiz="quiz" />
    </div>
    <div class="add-question" @click="addQuestion(quiz)">
      <AddQuestionIcon />
      Thêm câu hỏi mới
    </div>
  </div>
</template>

<script>
import Header from './Header'
import EditorQuestion from './EditorQuestion'
import AddQuestionIcon from '../../ui/icons/svgs/icons/AddQuestionIcon'


export default {
  name: "EditorListQuestion",
  components: {
    Header,
    EditorQuestion,
    AddQuestionIcon
  },
  data(){
    return{

    }
  },
  computed: {
    quiz: function() {
      return this.$store.getters.quiz
    },
  },
  methods: {
    addQuestion(quiz){
      quiz.action('addQuestion')
    }
  }

};
</script>
<style lang="scss">
  @import '~@/styles/editor.scss';
</style>
